import { animated, easings, useTransition } from '@react-spring/web';
import type { PropsWithChildren } from 'react';

export const FadeInOut = ({ children }: PropsWithChildren) => {
  const transitions = useTransition(children ? [children] : [], {
    keys: () => 'fade',
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: 300,
      easing: easings.easeInOutCubic,
    },
  });

  return transitions((style, item) => (
    <animated.div style={style}>{item}</animated.div>
  ));
};
